// Selectors
import { createSelector } from '@reduxjs/toolkit';
import { ApplicationState } from '../../store';


export const feedbackSelector = (state: ApplicationState) => state.feedbackState

export const feedbackLoadingSelector = createSelector(feedbackSelector, (state) => state.loading);
